import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { PageTitleService } from '../../core/services/page-title.service';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  user: any = null;
  profilePic: string | null = null;

  quickLinks = [
    { icon: 'pe-7s-graph2',    label: 'Dashboard',      route: '/dashboard' },
    { icon: 'pe-7s-users',     label: 'Members',         route: '/members' },
    { icon: 'pe-7s-albums',    label: 'Books',           route: '/books' },
    { icon: 'pe-7s-way',       label: 'Routes',          route: '/routes' },
    { icon: 'pe-7s-home',      label: 'Centers',         route: '/centers' },
    { icon: 'pe-7s-refresh-2', label: 'Issue / Receive', route: '/issue-receive' },
  ];

  constructor(
    private auth: AuthService,
    private pageTitle: PageTitleService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.user = this.auth.getCurrentUser();
    this.profilePic = this.auth.getProfilePic();
    this.pageTitle.set('My Profile', 'Your account information');
  }

  get initial(): string {
    return (this.user?.name || 'U').charAt(0).toUpperCase();
  }

  get roleLabel(): string {
    const r = this.user?.role?.toLowerCase();
    if (r === 'admin')   return 'Administrator';
    if (r === 'manager') return 'Center Manager';
    if (r === 'runner')  return 'Book Runner';
    return this.user?.role || 'User';
  }

  get roleClass(): string {
    const r = this.user?.role?.toLowerCase();
    if (r === 'admin')   return 'role--admin';
    if (r === 'manager') return 'role--manager';
    if (r === 'runner')  return 'role--runner';
    return '';
  }

  openFilePicker(): void {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) return;

    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result as string;
      this.profilePic = base64;
      this.auth.setProfilePic(base64);
    };
    reader.readAsDataURL(file);
    // reset so the same file can be re-selected
    this.fileInput.nativeElement.value = '';
  }

  removePhoto(): void {
    this.profilePic = null;
    this.auth.clearProfilePic();
  }

  navigate(route: string): void {
    this.router.navigateByUrl(route);
  }

  goBack(): void {
    this.router.navigateByUrl('/dashboard');
  }
}
